<template>
  <a-button
    :block="block"
    :size="size"
    :loading="loading"
    :disabled="disabled"
    class="auth-submit-button"
    :type="type"
    :html-type="htmlType"
  >
    <slot>
      {{ loading ? loadingText : defaultText }}
    </slot>
  </a-button>
</template>

<script>
export default {
  name: "AuthSubmitButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "large",
    },
    loadingText: {
      type: String,
      default: "Carregando...",
    },
    defaultText: {
      type: String,
      default: "Continuar",
    },
     type: {
      type: String,
      default: 'submit'
    },
    htmlType: {
      type: String,
      default: "button",
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-submit-button {
  height: 42px;
  border-radius: 8px;
  background-color: #ff7043;
  border-color: #ff7043;
  font-weight: 600;
  color: #212121;

  &:hover,
  &:focus {
    background-color: #ff5722;
    border-color: #ff5722;
    color: #212121;
  }

  &:disabled {
    background-color: #f5f5f5;
    border-color: #c7c9d9;
    color: #bdbdbd;
  }
}
</style>
